import { render } from "./InputDateCustom.vue?vue&type=template&id=834a631c"
import script from "./InputDateCustom.vue?vue&type=script&lang=js"
export * from "./InputDateCustom.vue?vue&type=script&lang=js"

import "./InputDateCustom.vue?vue&type=style&index=0&id=834a631c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__